/**
 * @generated SignedSource<<82a5b792866620ec2263e953d663eee5>>
 * @relayHash e40d50d63c2471f125fb17c4d9f52651
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e2691e47af9434c4f51a5b8d62ef778ce4e472319f82fb503191ebe9512b75d3

import type { ConcreteRequest } from 'relay-runtime';
export type useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery$variables = {
  cloudId: string;
  id: string;
};
export type useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery$data = {
  readonly confluence_resolvedSpaceKeyForContent: string | null;
};
export type useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery = {
  response: useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery$data;
  variables: useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "confluence_resolvedSpaceKeyForContent"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e40d50d63c2471f125fb17c4d9f52651",
    "id": "e2691e47af9434c4f51a5b8d62ef778ce4e472319f82fb503191ebe9512b75d3",
    "metadata": {},
    "name": "useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery",
    "operationKind": "query",
    "text": "query useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery($cloudId:ID!,$id:ID!){confluence_resolvedSpaceKeyForContent(cloudId:$cloudId,id:$id)}"
  }
};
})();

(node as any).hash = "99120215e3cab15df2137f63795c234f";

export default node;
